import { TextInput } from '@core/components/Inputs';
import { Grid, IconButton, InputAdornment, Tooltip } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import { FieldArray } from 'formik';
import React from 'react';
import { BotaoContato } from './BotaoContato';

const Email = ({ arrayHelpers, index, email, contatoIndex, handleChange, handleBlur, touched, error, readOnly }) => {
  return (
    <Grid container spacing={3} key={index} className="mt-10">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          readOnly={readOnly}
          required={email.email && touched && error}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Excluir registro" placement="bottom">
                  <IconButton onClick={() => arrayHelpers.remove(index)}>
                    <RemoveCircleIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
          id={`pessoa.contatos[${contatoIndex}].emailsAdicionais[${index}].email`}
          fullWidth
          value={email.email}
          onChange={handleChange}
          onBlur={handleBlur}
          label="E-mail adicional"
          maxLength={100}
          touched={touched}
          error={error}
        />
      </Grid>
    </Grid>
  );
};

const EmailAdicional = ({
  contatoIndex,
  emailsAdicionais = [],
  handleChange,
  handleBlur,
  error = [],
  touched = [],
  readOnly,
}) => {
  const exibirAdicionar = emailsAdicionais.length < 2;

  return (
    <FieldArray name={`pessoa.contatos[${contatoIndex}].emailsAdicionais`}>
      {(arrayHelpers) => {
        const emails = emailsAdicionais.map((item, index) => {
          return (
            <Email
              key={index}
              readOnly={readOnly}
              handleChange={handleChange}
              handleBlur={handleBlur}
              contatoIndex={contatoIndex}
              email={item}
              index={index}
              arrayHelpers={arrayHelpers}
              touched={touched[index] && touched[index].email}
              error={error[index] && error[index].email}
            />
          );
        });
        return (
          <>
            {emails}
            {!readOnly && exibirAdicionar && (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <BotaoContato onClick={() => arrayHelpers.push({})}>Adicionar e-mail</BotaoContato>
              </Grid>
            )}
          </>
        );
      }}
    </FieldArray>
  );
};

export default EmailAdicional;
